<template>
  <div>
    <DataInline
      v-if="raw_fields.type == 'BPInlineBoxData'"
      :parsed_fields="parsed_fields"
      :raw_fields="raw_fields"
      :readonly="readonly"
      :lang="lang"
      :is_mobile="is_mobile"
      :json="json"
      @update="update"
    />
  </div>
</template>


<style lang="scss">
.no_click {
  pointer-events: none;
}
</style>


<script>
import DataInline from '@/components/bpcreator/inputs/inlines/DataInline'
import CustomInput from '@/components/inputs/CustomInput.vue'
import AddFormItem from '@/components/bpcreator/model/AddFormItem'


export default {
  components: {
    CustomInput,
    AddFormItem,
    DataInline,
  },

  name: 'InlineInput',

  props: ['raw_fields','parsed_fields','json','readonly','is_mobile','lang'],

  data: () => ({
    form: null,
    values: {},
    open: false,
    field_to_modify: {},
  }),

  computed: {
    fieldlist() {
      // Returns a list with all fields [field1, field2...]
      return []//this.parsed_fields.flat();
    },
    is_valid() {
      return this.form;
    },
    forced_cols() {
      return screen.width <= 600 ? 12 : 0;
    },
  },

  beforeMount() {
    for (const field of this.fieldlist) {
      this.values[field.id] = field.value;
    }
  },

  methods: {
    update(value) {
      this.$emit('update',value);
    },
  },
  watch: {
    is_valid(val) {
      this.$emit('ready', val);
    },
  },
}
</script>


